'use client'

import { Button } from '@/packages/news-ui/basic/button'
import { getPublicEnv } from '@/shared/env'
import { useI18n } from '@/shared/providers'

export function LoggedIn() {
    const { i18n } = useI18n()
    const runtimeEnv = getPublicEnv()

    return (
        <Button
            variant="outline"
            size="sm"
            onClick={() => {
                window.location.href = `${runtimeEnv.NEXT_PUBLIC_TAONGA_PORTAL_URL}/account`
            }}
        >
            {i18n.PORTAL_PROFILE}
        </Button>
    )
}
